"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIDE_PROFILE_ELEMENT = void 0;
var _types = require("../types");
const HIDE_PROFILE_ELEMENT = exports.HIDE_PROFILE_ELEMENT = [_types.EProfileElementStatus.Disabled, _types.EProfileElementStatus.Readonly, _types.EProfileElementStatus.Readonly];
